document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.faq')) {
        // $(document).on("scroll");
        if (window.location.hash) {
            let hash = window.location.hash;
            if ((document.querySelector(`[data-target="${hash}"]`) !== undefined) && hash.length>6) {

                setTimeout(function () {
                    $(`[data-target='${hash}']`).trigger('shown.bs.target');
                    $('body,html').animate({scrollTop: $(hash).offset().top - 182}, 'slow');
                }, 500)

            }
        }
    }
})